import withIcon from './NewIcon';
// @ts-ignore
import IconRankL from './icon/l/rank.s.svg';

export default withIcon(IconRankL);
